export const ServiceOrderStatus = Object.freeze({
  NEW: 1,
  SIGNED: 2,
  IN_PROGRESS: 3,
  COMPLETED:4,
  PENDING_APPROVAL: 5,
  APPROVAL_EXPIRED: 6,
  DECLINED: 7,
});

export default ServiceOrderStatus;